import { render, staticRenderFns } from "./NewHome.vue?vue&type=template&id=0f2020fd&scoped=true"
import script from "./NewHome.vue?vue&type=script&lang=js"
export * from "./NewHome.vue?vue&type=script&lang=js"
import style0 from "./NewHome.scss?vue&type=style&index=0&id=0f2020fd&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2020fd",
  null
  
)

export default component.exports